export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5">
          关于成全影院
        </h2>
        <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
          <p>
            成全影院成立于2024年，是一个专注于高清画质在线观影的平台。我们致力于为广大影迷提供<strong className="text-foreground-800">流畅不卡顿</strong>的蓝光观影体验，收录超过两万部<strong className="text-foreground-800">电影大全</strong>和<strong className="text-foreground-800">电视剧全集</strong>。
          </p>
          <p>
            平台坚持<strong className="text-foreground-800">免费在线观看</strong>的运营理念，全程<strong className="text-foreground-800">无广告干扰</strong>，让每一位用户都能沉浸在纯粹的光影世界中。我们采用分布式CDN加速网络和智能码率自适应技术，无论您使用什么设备、身处何种网络环境，都能畅享<strong className="text-foreground-800">高清画质流畅播放</strong>的观影乐趣。
          </p>
          <p>
            成全影院的内容团队由一群热爱电影的专业编辑组成，每日精选<strong className="text-foreground-800">最新影片</strong>和经典佳作，覆盖动作、喜剧、悬疑、爱情、科幻等全品类，满足不同观众的多元观影需求。成全影院，让每一次观影都成为享受。
          </p>
        </div>
      </div>
    </section>
  );
}